import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ManufacturedHomeDetailsStep } from '../../../models/wizard/manufactured-home-details-step.model';
import { WizardStepComponentBase } from '../wizard-step-base.component';
import { MortgageApplication } from '../../../models/mortgage-app.model';
import { EnumsService } from '../../../services/enums.service';
import { Constants } from '../../../services/constants';
import { EnumerationItem } from 'projects/shared/models/enumeration-item.model';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'manufactured-home-details-step',
    templateUrl: 'manufactured-home-details-step.component.html',
    standalone: false
})
export class ManufacturedHomeDetailsStepComponent
  extends WizardStepComponentBase<ManufacturedHomeDetailsStep>
  implements OnInit
{
  @ViewChild('manufacturedHomeDetailsForm')
  protected manufacturedHomeDetailsForm: NgForm;

  protected mortgage: MortgageApplication;

  protected landTypes: EnumerationItem[] = [];
  protected sizeOfLandTypes: EnumerationItem[] = [];
  protected lotOwnershipTypes: EnumerationItem[] = [];

  constructor(
    private readonly _injector: Injector,
    private readonly _enumsService: EnumsService
  ) {
    super(_injector);
    this._enumsService.getMortgageEnumerations().subscribe((enums) => {
      this.landTypes = this._enumsService.translateEnumArray(
        enums[Constants.mortgageEnumerations.landType], 'landType');
      this.sizeOfLandTypes = this._enumsService.translateEnumArray(
        enums[Constants.mortgageEnumerations.sizeOfLandType], 'sizeOfLand');
      this.lotOwnershipTypes = this._enumsService.translateEnumArray(
        enums[Constants.mortgageEnumerations.lotOwnershipType], 'lotOwnership');
    });
    this.mortgage = this.mortgageApplication;
  }

  onNextClicked(): void {
    this.manufacturedHomeDetailsForm.form.markAllAsTouched();
    if (this.manufacturedHomeDetailsForm.form.valid) {
      super.onNextClicked();
    }
  }
}
